<template>
    <el-dialog class="el-dialogs" :title="title" :fullscreen="true" :close-on-click-modal="false"
               :visible.sync="visible">
        <el-row :gutter="4" class="h100 metadata">
            <el-col :span="showList ? 4 : 1" :class="['p_r h100i', showList ? '' : 'el-col-unfold']"
                    v-loading="showList && treeLoading">
                <div :class="['unfoldClassifyBtn', showList ? 'el-icon-arrow-left':'el-icon-arrow-right']"
                     @click="showList = !showList"></div>
                <el-menu class="h100 metadataTree" :default-active="searchForm.basicDataId" @select="selectMenu">
                    <el-menu-item :index="item.basicDataId" v-for="item in basicDataList" :key="item.basicDataId" v-if="item.basicDataName">
                        <span slot="title">{{ item.basicDataName }}</span>
                    </el-menu-item>
                </el-menu>
            </el-col>
            <el-col :span="showList ? 20 : 24" :class="['h100', showList ? '' : 'el-col-unfold']">
                <div class="el-table-container metadataTree">
                    <el-form size="small" class="query-form" ref="form" :inline="true" :model="searchForm"
                             label-width="120px" @keyup.enter.native="refreshList(1,1)" @submit.native.prevent>
                        <el-form-item prop="keyword" label="关键字：">
                            <el-input v-model.trim="searchForm.keyword" maxlength="20"
                                      placeholder="请输入关键字(限20字)"
                                      clearable></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="refreshList(1,1)" size="small" icon="el-icon-search">查询
                            </el-button>
                            <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
                        </el-form-item>
                        <el-form-item class="f_r">
                            <el-button type="primary" size="small" @click="disassociate()">解除关联</el-button>
                            <el-button type="primary" size="small" @click="exportData()">导出</el-button>
                        </el-form-item>
                    </el-form>
                    <el-table
                            :data="dataList"
                            size="small" height="100%"
                            class="table" ref="multipleTable" border
                            @selection-change="selectionChangeHandle" @sort-change="sortChangeHandle" row-key='id'
                            v-loading="loading">
                        <el-table-column type="selection" :reserve-selection='true' fixed/>
                        <el-table-column prop="netUrl" label="缩略图" width="130px">
                            <template slot-scope="{row}">
                                <el-image
                                        style="width: 100px; height: 100px"
                                        :src="row.suoluetu" :preview-src-list="[row.suoluetu]"
                                        fit="cover">
                                    <template slot="error" class="image-slot">
                                        <el-image
                                            style="width: 100px;height: 100px"
                                            :src="require('@/assets/img/default.png')"
                                            fit="fill">
                                        </el-image>
                                    </template>
                                </el-image>
                            </template>
                        </el-table-column>
                        <el-table-column prop="mingcheng" label="资源名称" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="createByName" label="关联人" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="zhuanti" v-if="dataType == 0" label="专题" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="fenzu" v-else label="分组" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="zhuangtai" label="状态" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="createDate" label="关联时间" sortable show-overflow-tooltip></el-table-column>
                        <el-table-column prop="totalCount" label="附件数量" sortable show-overflow-tooltip></el-table-column>
                        <el-table-column prop="fileSizeSum" label="附件大小" sortable show-overflow-tooltip></el-table-column>
                        <el-table-column fixed="right" label="操作" width="280">
                            <template slot-scope="{row}">
                                <el-button type="text" size="small" @click="disassociate(row)">解除关联</el-button>
                                <el-button type="text" size="small" @click="detail(row)">详情</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                                @pagination="refreshList"/>
                </div>
            </el-col>
        </el-row>
        <ResourceAddEditForm ref="resourceAddEditForm"></ResourceAddEditForm>
    </el-dialog>
</template>

<script>
import ResourceAddEditForm from '@/views/modules/dyygCollect/library/resourceAddEditForm'

export default {
    name: "optResources",
    components: {ResourceAddEditForm},
    data() {
        return {
            title: '关联资源',
            visible: false,
            treeLoading: false,
            showList: true,
            basicDataList: [],
            searchForm: {
                basicDataId: '',
                keyword: '',
                orderBy:"",
                current: 1,
                size: 20,
                // whereList: [],
            },
            loading: false,
            dataList: [],
            dataListSelections: [],
            total: 0,
            selectData: {},
            dataType: 0,
        }
    },

    methods: {
        // num 0专题 1分组
        init(row, dataType) {
            this.visible = true
            this.selectData = row
            this.dataType = dataType
            this.$nextTick(() => {
                this.$refs.form.resetFields()
            })
            this.getField()
        },

        // 获取元数据模板
        getField() {
            this.treeLoading = true
            this.$axios(this.api.academic.getBasicDataList, {}, 'get').then(data => {
                if (data.status) {
                    this.basicDataList = data.data
                    this.selectMenu(this.basicDataList[0].basicDataId)
                } else {
                    this.$message.error(data.msg)
                }
                this.treeLoading = false
            })
        },

        // 选择树节点
        selectMenu(val) {
            this.searchForm.basicDataId = val
            this.reset()
        },

        // 重置
        reset() {
            this.searchForm.keyword = ''
            this.refreshList(1, 3)
        },

        // 获取数据列表 current: 1第一页
        refreshList(current, searchType) {
            if (current == 1) {
                this.searchForm.current = 1
            }
            if (searchType) {
                this.$refs.multipleTable.clearSelection()
            }
            this.loading = true
            this.$axios(this.api.academic.relevancedataList, {
                ...this.searchForm,
                dataType: this.dataType,
                thematicId: this.selectData.id,
            }, 'get').then(data => {
                if (data.status) {
                    this.dataList = data.data.data
                    if (this.dataList.length == 0 && this.searchForm.current > 1) {
                        this.searchForm.current--
                        this.refreshList()
                    }
                    this.total = parseInt(data.data.total)
                    this.loading = false
                } else {
                    this.$message.error('查询失败');
                }
            })
        },

        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val
        },

        // 列表排序
        sortChangeHandle(obj) {
            // obj.prop = this.getHumpLineName(obj.prop);
            // if (obj.order === 'ascending') {
            //     this.searchForm.orderBy = obj.prop + ' asc'
            // } else if (obj.order === 'descending') {
            //     this.searchForm.orderBy = obj.prop + ' desc'
            // } else {
            //     this.searchForm.orderBy = ''
            // }
            // this.refreshList(1, 1)
        },

        //解除关联
        disassociate(row) {
            let list = row ? [row] : this.dataListSelections
            if (list.length == 0) {
                this.$message.warning('请至少选择一条数据')
                return
            }
            let ids = list.map(item => {
                return item.id
            })
            this.$confirm(`您是否确认解除关联?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios(this.api.academic.relevancedataRemoveByI, {
                    dataType: this.dataType,
                    ids,
                }, 'post').then(data => {
                    if (data && data.status) {
                        this.$message.success('解除关联成功')
                        this.refreshList('', 1)
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },

        //详情
        detail(row) {
            this.$refs.resourceAddEditForm.init('view', row.resourcesId, '', this.searchForm.basicDataId)
        },

        //导出
        exportData() {
            if (this.total == 0) {
                this.$message.warning('暂无可导出的数据！')
                return
            }
            let ids = this.dataListSelections.map(item => {
                return item.id
            })
            this.exportExcel(this.api.academic.relevancedataExport, {
                ids,
                ...this.searchForm,
                dataType: this.dataType,
                thematicId: this.selectData.id,
            }, '关联资源列表', 'post')
        },
    },
}
</script>

<style scoped>
.metadata {
    padding: 3px;
    background: #EBEEF5;
}

.metadataTree {
    border-radius: 5px;
    background: #ffffff;
}

.el-menu {
    border-right: none !important;
}

.el-menu-item, .el-submenu__title {
    height: 34px !important;
    line-height: 34px !important;
    font-size: 14px;
}
</style>
